<template>
  <b-row>
    <b-col cols="12">
      <b-form @submit.prevent>
        <b-form-group
          label="انتخاب زبان آموز مورد نظر"
          label-for="vip-user-picker"
        >
          <v-select
            @search="handleSearch"
            :disabled="isDisabled"
            id="vip-user-picker"
            dir="rtl"
            :filterable="false"
            v-if="usersList"
            :reduce="(user) => user.userId"
            v-model="selectedUserId"
            :options="usersList"
            label="fullName"
            placeholder="زبان آموز را انتخاب کنید"
          >
            <template #no-options>هیچ زبان آموزی جهت نمایش وجود ندارد</template>
          </v-select>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>
</template>
<script>
export default {
  emits: ["getUserId"],
  props: {
    defaultUserId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    selectedUserId: {
      handler(val) {
        this.$emit("getUserId", val);
      },
    },
    defaultUserId: {
      handler(val) {
        if ((val && val != "" && val != 0) || val == null) {
          this.getAllVipUsers();
        }
      },
    },
  },
  mounted() {
    this.getAllVipUsers();
  },
  data() {
    return {
      usersList: null,
      selectedUserId: null,
      searchVal: null,
      timeout: null,
    };
  },
  methods: {
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.searchVal = searchValue;
        loadingFn(true);
        await this.getAllVipUsers();
        loadingFn(false);
      }, 300);
    },

    async getAllVipUsers() {
      try {
        this.isLoading = true;
        let _this = this;
        let getVipUsersList = new GetVipUsersList(_this);
        let qParams = {};
        if (_this.searchVal) {
          qParams["fullname"] = _this.searchVal;
        }
        if (_this.defaultUserId) {
          qParams["userId"] = _this.defaultUserId;
        }
        getVipUsersList.setRequestParam(qParams);
        await getVipUsersList.fetch((res) => {
          _this.usersList = res;
          if (_this.defaultUserId) {
            _this.selectedUserId = _this.defaultUserId;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
  },
};
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { GetVipUsersList } from "@/libs/Api/Users";
// import { GetAllLanguages } from "@/libs/Api/Language";
</script>
